var render = function render(){var _vm=this,_c=_vm._self._c;return _c('live-speed-zone-form',{attrs:{"loading":_vm.loading,"live-stage-id":_vm.liveStageId,"stage-routes":_vm.stageRoutes,"stage-waypoints":_vm.stageWaypoints,"stage-speed-zones":_vm.stageSpeedZones,"live-categories":_vm.liveCategories},on:{"submit":_vm.submitZones}})
}
var staticRenderFns = []

export { render, staticRenderFns }